const images = [
  "/img1.jpg",
  "/img2.png",
  "/img8.jpg",
  "/img5.jpg",
  "/img6.jpg",
  "/img4.jpg",
  "/img7.jpg",
  "/img10.png",
  "/img11.jpg",
  "/img12.jpg",
  "/img13.jpg",
  "/img14.jpg",
  "/img15.jpg",
  "/img16.jpg",
  "/img17.jpg",
  "/img18.jpg",
  "/img19.jpg",
  "/img20.jpg",
  "/img21.jpg",
  "/img22.jpg",
  "/img24.jpg",
  "/img25.jpg",
  "/img26.jpg",
  "/img27.jpg",
  "/img28.jpg",
  "/img29.jpg",
  "/img30.jpg",
  "/img31.jpg",
];

export default function Gallery() {
  return (
    <div className="max-w-6xl mx-auto p-8">
      <h2 className="text-4xl font-heading mb-8 text-center text-chrome">
        Gallery
      </h2>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
        {images.map((src, i) => (
          <div
            key={i}
            className="group relative overflow-hidden"
          >
            <a href="https://www.instagram.com/throttled_ink/?hl=en" target="_blank" rel="noreferrer">
            <img
              src={src}
              alt={`Tattoo ${i + 1}`}
              className="w-full h-92 object-cover group-hover:scale-110 transition"
            />
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
              <p className="text-white uppercase tracking-widest">Throttled Ink</p>
            </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}